const files = require.context("./modules", false, /\.js$/);
// const modules = {};
function camelCase(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}
files.keys().forEach(fileName => {
  if (fileName === "./service.js") return;
  let name = fileName.replace(/(\.\/|\.js)/g, "").replace(/(\.\/|\.)/g, " ");
  const moduleName = camelCase(name.replace(/(\.\/|\.js)/g, ""));
  //modules[moduleName] = files(fileName);
  exports[moduleName] = files(fileName);
});
// export default modules;
